import {useEffect} from 'react'
import {AddReceiverModalHeader} from './AddReceiverModalHeader'
import {AddReceiverModalFormWrapper} from './AddReceiverModalFormWrapper'

const AddReceiverModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_receiver'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-1000px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <AddReceiverModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y py-lg-10 px-5 px-lg-10'>
              <AddReceiverModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {AddReceiverModal}
